import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/54/thumb-landscape.jpg"

const Post54 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Dior Book Tote：右前 Mini / 左前 Small / 右後 Medium / 左後 Large</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            Diorの「ブックトート」。もはや説明不要のアイコンバッグですね。その圧倒的な存在感と、どんなスタイルにも馴染む汎用性の高さで、世界中のファッショニスタを魅了し続けています。しかし、サイズ展開が豊富すぎて「どれを選べばいいの？」と頭を抱える方も少なくないはずです。<br></br>
            今回は「ミニ」「スモール」「ミディアム」「ラージ」の全4サイズを徹底比較！それぞれの特徴から、どんなライフスタイルにフィットするのかまで、じっくりと解説していきます。この記事を読めば、あなたの「運命のブックトート」がきっと見つかるはずです。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">            
      <div id ="sec1" className="text-max-width">
        <h2>なぜ今、「ブックトート」なのか？</h2>
      </div>
      <p className="text-max-width">Diorのブックトートは、2018年春夏コレクションでマリア・グラツィア・キウリが発表して以来、瞬く間に世界を席巻しました。その魅力は、実用性を超えて芸術作品のような美しさを放っている点にあります。</p>
      <p className="text-max-width">まず目を引くのは、刺繍。メゾンのサヴォワールフェール（匠の技）が凝縮された緻密なデザインは、持つ人の個性を際立たせ、シンプルな装いをも一瞬で格上げしてくれます。そして、その堅牢なキャンバス素材は、日常使いにも十分な耐久性を兼ね備え、まさに「美しさと実用性」を両立した稀有なバッグと言えるでしょう。</p>
      <p className="text-max-width">さらに、トレンドに左右されないデザインも、長く愛される理由の一つ。どんな時代にもフィットし、持つ人のスタイルを確立してくれる。そんな普遍的な魅力が、ブックトートには宿っているのです。</p>
      <div id ="sec2" className="text-max-width">
        <h1>まるっと早わかり！Diorブックトート全4サイズ比較</h1>
      </div>
      <p className="text-max-width space-bottom">さて、本題のサイズ比較に移りましょう。それぞれのサイズが持つ個性と、おすすめのシチュエーションを詳しく見ていきます。</p>
      <figure>
        <StaticImage src="../../images/posts/54/1.jpg"/>
      </figure>
      <span className="text-center">Dior / Mini / 22 x 15 x 6cm</span>  
      <h2><span className="text-background-pink">【 Mini 】アクセサリー感覚で楽しむ、最旬トレンドサイズ</span></h2>
      <p className="text-max-width">ここ数年で登場し、ミニバッグトレンドの火付け役ともなった「ミニ」。その名の通り、ブックトートの中で最もコンパクトなサイズです。</p>
      <p className="text-max-width">
        <span className="text-border-bottom text-background-gray">おすすめポイント</span><br></br>
        まさに「アクセサリー感覚」で持てるのが最大の魅力。スマートフォン、ミニウォレット、リップなど、最低限の必需品だけを入れて身軽に出かけたい時に重宝します。小ぶりながらもDiorのロゴがしっかりと主張し、コーディネートのアクセントとして抜群の存在感を発揮。カジュアルなデニムスタイルにエレガントなひねりを加えたり、ドレッシーなワンピースに遊び心を添えたりと、使い方は無限大です。トレンドに敏感なファッショニスタには特におすすめしたいサイズです。
      </p>
      <p><span className="text-border-bottom text-background-gray">使用シチュエーション</span></p>
      <ul className="list-style-disc">
        <li>ちょっとそこまでのワンマイルコーデに</li>
        <li>パーティーや結婚式の二次会など、華やかなシーンで</li>
        <li>旅行先でのサブバッグとして、観光を楽しみたい時</li>
        <li>普段使いのメインバッグに加えて、もう一点差し色として持ちたい時</li>
        <li>ミニマルなライフスタイルを送る方</li>
      </ul>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom text-background-gray">ラクサス編集者の視点</span><br></br>
        正直なところ、収納力は期待できません。しかし、このサイズ感だからこそ得られる「こなれ感」は絶大です。あえて荷物を絞り込むことで、身のこなしも軽やかになり、より洗練された印象を与えます。カジュアルなスウェットスタイルに合せるだけで、一気にモードな雰囲気に早変わり。まさに今、最も旬な持ち方と言えるでしょう。
      </p>
      <figure>
        <StaticImage src="../../images/posts/54/2.jpg"/>
      </figure>
      <span className="text-center">Dior / Small / 26 x 21 x 14cm</span>  
      <h2><span className="text-background-pink">【 Small 】日常に溶け込む、絶妙なバランスサイズ</span></h2>
      <p className="text-max-width">ミニよりも一回り大きく、日常使いに最も適していると呼び声高いのが「スモール」サイズ。A4サイズの書類はさすがに難しいものの、普段使いに必要なものが無理なく収まります。</p>
      <p className="text-max-width">
        <span className="text-border-bottom text-background-gray">おすすめポイント</span><br></br>
        コンパクトでありながらも、長財布、スマートフォン、コスメポーチ、手帳、文庫本など、普段持ち歩く必需品がしっかり収納できます。大きすぎず、小さすぎないこの絶妙なサイズ感は、どんな身長や体型の方にもバランスよく馴染みます。腕にかけて持つことが出来るハンドルの長さです。初めてのブックトートにもおすすめできる、汎用性の高さが魅力です。
      </p>
      <p><span className="text-border-bottom text-background-gray">使用シチュエーション</span></p>
      <ul className="list-style-disc">
        <li>デイリーユースのメインバッグとして</li>
        <li>友人とのランチやカフェ巡り</li>
        <li>ちょっとしたショッピングや散策</li>
        <li>お子様との公園遊び（最小限の荷物で）</li>
        <li>上品さを保ちつつ、実用性を重視したい方</li>
      </ul>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom text-background-gray">ラクサス編集者の視点</span><br></br>
        「ミニは小さすぎるけど、ミディアムは大きすぎる…」と感じる方にこそ、スモールは最適な選択肢です。ブックトート特有の存在感はそのままに、街中で浮くことなく、しっくりと馴染むサイズ感は本当に優秀。カジュアルなTシャツスタイルから、きれいめなワンピースまで、幅広いコーディネートにマッチし、ワンランク上のカジュアルシックを叶えてくれます。
      </p>
      <figure>
        <StaticImage src="../../images/posts/54/3.jpg"/>
      </figure>
      <span className="text-center">Dior / Medium / 36 x 27 x 16cm</span>  
      <h2><span className="text-background-pink">【 Medium 】ビジネスシーンもOK！頼れる万能サイズ</span></h2>
      <p className="text-max-width">元々「スモール」と呼ばれていたサイズが、2022年に「ミディアム」に名称変更され、より多くの荷物に対応できる、頼れるサイズとして定着しました。A4サイズの書類やノートPCも収納可能なので、通勤・通学バッグとしても人気です。</p>
      <p className="text-max-width">
        <span className="text-border-bottom text-background-gray">おすすめポイント</span><br></br>
        A4ファイルや薄型のノートPC、タブレット、ペットボトルなど、ビジネスシーンで必要なアイテムがすっぽり収まる大容量が魅力。しかし、ただ大きいだけでなく、ブックトートらしい洗練されたデザインは健在。会議やクライアントとの重要な打ち合わせでも、好印象を与えられるでしょう。荷物が多くなりがちな方や、通勤・通学でブックトートを使いたい方に最適なサイズです。
      </p>
      <p><span className="text-border-bottom text-background-gray">使用シチュエーション</span></p>
      <ul className="list-style-disc">
        <li>通勤、通学バッグとして</li>
        <li>一泊程度の出張や旅行</li>
        <li>お稽古バッグやジムバッグとして</li>
        <li>週末のお出かけやショッピングに</li>
        <li>荷物が多くてもおしゃれを諦めたくない方</li>
      </ul>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom text-background-gray">ラクサス編集者の視点</span><br></br>
        ミディアムサイズは、日々のあらゆるシーンにフィットする、使い勝手の良さが魅力的です。かっちりとしたビジネススタイルに合わせるのはもちろん、あえてTシャツやカジュアルなワイドパンツに合わせて、抜け感を出すのもおすすめです。1泊の出張で利用したことがありますが、ノートPC、1泊の着替えなど十分入るサイズでとっても重宝しました！
      </p>
      <figure>
        <StaticImage src="../../images/posts/54/4.jpg"/>
      </figure>
      <span className="text-center">Dior / Large/ 42 x 35 x 17cm</span>  
      <h2><span className="text-background-pink">【 Large 】圧倒的な存在感！旅行やマザーズバッグにも</span></h2>
      <p className="text-max-width">ブックトートのラインナップの中で、最も大きく、圧倒的な存在感を放つのが「ラージ」サイズ。その名の通り、たっぷりの荷物を収納できるキャパシティが魅力です。</p>
      <p className="text-max-width">
        <span className="text-border-bottom text-background-gray">おすすめポイント</span><br></br>
        短期の旅行や出張、お子様とのお出かけで荷物が多くなるマザーズバッグとしても大活躍します。着替えやタオルなども余裕で収納可能。その大容量でありながら、キャンバス素材なので見た目ほど重さを感じさせないのも嬉しいポイントです。ファッションアイテムとして楽しめるのはもちろん、実用性にも優れた「旅先で頼れる存在」として最適なバッグサイズです。
      </p>
      <p><span className="text-border-bottom text-background-gray">使用シチュエーション</span></p>
      <ul className="list-style-disc">
        <li>週末の旅行や出張</li>
        <li>マザーズバッグとして</li>
        <li>スポーツジムや習い事など</li>
        <li>推しのライブやイベントを楽しみたい時</li>
        <li>男性が持つことで、よりクールな印象に</li>
      </ul>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom text-background-gray">ラクサス編集者の視点</span><br></br>
        ラージサイズは、まさに「ブックトートを主役にしたコーディネート」を楽しめるサイズです。シンプルなワントーンコーデに、このバッグ一つでモード感が格段にアップします。身長が高い方や、普段からボリュームのあるファッションを好む方には特におすすめ。また、最近では男性がビジネスシーンでラージサイズを持つ姿もよく見かけます。性別問わず楽しめるのもブックトートの魅力ですね。
      </p>
      <figure>
        <StaticImage src="../../images/posts/54/5.jpg"/>
      </figure>
      <div id ="sec3" className="text-max-width">
        <h2>サイズ選びの最終アドバイス</h2>
      </div>
      <p className="text-max-width">いかがでしたでしょうか？それぞれのサイズに異なる魅力があるブックトート。最後に、あなたのサイズ選びを後押しするヒントをいくつかご紹介します。ぜひ、サイズ比較表もご参考ください。</p>
      <div className="table-wrapper" style={{marginBottom: "4rem"}}>
        <table border="1">
          <thead>
            <tr>
              <th className="table-title" colspan="6">Dior Book Tote サイズ比較表</th>
            </tr>
            <tr>
              <th aria-hidden="true"></th>
              <th className="cell-small">サイズ名</th>
              <th>サイズ（横x高さx幅cm）</th>
              <th className="cell-small">A4収納</th>
              <th>特徴・おすすめ用途</th>
              <th>収納例</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <figure>
                  <StaticImage src="../../images/posts/54/6.jpg"/>
                </figure>
              </td>
              <td>ミニ</td>
              <td>22 x 15 x 6cm</td>
              <td>❌</td>
              <td className="cell-left">コンパクトで軽量。スマホ・ウォレット・リップなど最低限の荷物に最適。クロスボディストラップ付きでハンズフリーに。カジュアルなランチや街歩きに◎。</td>
              <td className="cell-left">スマートフォン、ミニ財布、リップスティック、AirPodsケース、鍵、カードケース、ハンカチ</td>
            </tr>
            <tr>
              <td>
                <figure>
                  <StaticImage src="../../images/posts/54/7.jpg"/>
                </figure>
              </td>
              <td>スモール</td>
              <td>26 x 21 x 14cm</td>
              <td>❌</td>
              <td className="cell-left">A5サイズの本や小型タブレットが収納可能。マチ幅14cmで折り畳み傘や小型カメラも収納可能。スタンダードな使い勝手でデイリー使いに便利。</td>
              <td className="cell-left">長財布、スマートフォン、小さめのコスメポーチ、文庫本、タブレット（iPad mini程度）、サングラス、手帳</td>
            </tr>
            <tr>
              <td>
                <figure>
                  <StaticImage src="../../images/posts/54/8.jpg"/>
                </figure>
              </td>
              <td>ミディアム</td>
              <td>36 x 27 x 16cm</td>
              <td>⭕️</td>
              <td className="cell-left">A4書類やミニパソコンが入る大容量。週末の小旅行や買い物バッグとして。トート型ながら立体感のあるシルエットでスタイリッシュ。</td>
              <td className="cell-left">A4ファイル、13〜15インチ程度のノートPC、手帳、大きめのポーチ、折りたたみ傘、ストールや薄手のカーディガン。</td>
            </tr>
            <tr>
              <td>
                <figure>
                  <StaticImage src="../../images/posts/54/9.jpg"/>
                </figure>
              </td>
              <td>ラージ</td>
              <td>42 x 35 x 17cm</td>
              <td>⭕️</td>
              <td className="cell-left">最大サイズで荷物たっぷり収納。旅行の機内持ち込みに最適。存在感あるデザインでファッションの主役に。</td>
              <td className="cell-left">1泊程度の着替え、厚手の雑誌、A4ファイル、15インチ以上のノートPC、タブレット、大きめのポーチ、スカーフ。</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="text-indent">
        <p className="text-max-width">1. <span className="text-border-bottom">ライフスタイルと荷物の量から考える</span></p>
        <ul className="list-style-disc" style={{marginLeft: "3rem"}}>
          <li>普段から持ち歩くものが少ない方、身軽に動きたい方は「ミニ」または「スモール」。</li>
          <li>日常使いに加えて、A4書類やPCを持ち運ぶことが多い方は「ミディアム」。</li>
          <li>旅行やマザーズバッグとして、とにかく大容量が必要な方は「ラージ」。</li>
        </ul> 
        <p className="text-max-width">2. <span className="text-border-bottom">身長や体型とのバランスを考慮する</span></p> 
        <ul className="list-style-disc" style={{marginLeft: "3rem"}}>
          <li>小柄な方は「ミニ」や「スモール」がバランスを取りやすいでしょう。</li>
          <li>高身長の方や、ボリュームのあるファッションを好む方は「ミディアム」や「ラージ」も検討してみてください。</li>
        </ul>
        <p className="text-max-width">3. <span className="text-border-bottom">試着はマスト！シェアリングサービスも活用して</span></p>
        <p style={{margin: "0 0 0 1.2rem"}}>
          実際に店舗で全てのサイズを試着してみることを強くおすすめします。鏡の前で、普段のコーディネートに近い服装で試着することで、よりリアルなイメージを掴むことができます。<br></br><br></br>
          とはいえ、「お店に行くのは緊張する」「時間がなくて店舗に足を運べない」と感じる方も少なくありません。そんなときに便利なのがシェアリングサービスサービスです。<br></br><br></br>
          購入を検討しているけれど、まずは実際に自分のライフスタイルに合うか試してみたい、という方は、ラクサスで気になるサイズのブックトートを借りて<span className="text-font-bolder">「お試し」</span>してみるのも賢い選択です。<span className="text-font-bolder">実際、多くのユーザーの方に、購入前のお試しとしてラクサスをご利用いただいています。</span>普段使いの中で、本当に必要なサイズ感や使い勝手を確認できるため、失敗しないバッグ選びに繋がるでしょう。
        </p> 
        <p className="text-max-width">4. <span className="text-border-bottom">「なりたい自分」をイメージする</span></p>
        <p style={{margin: "0 0 0 1.2rem"}}>
          どんなシーンで、どんなスタイルでブックトートを持ちたいですか？「アクセサリー感覚でトレンドを楽しみたい」「日常に上品さをプラスしたい」「ビジネスシーンでも活躍させたい」「旅のお供にしたい」など、あなたの「なりたい自分」をイメージすることで、最適なサイズがきっと見つかります。
        </p>
      </div>
      <p className="text-max-width">
        ぜひ、この記事を参考に、あなたのライフスタイルにぴったりの「運命のBag」を見つけて、Diorの世界観を存分に楽しんでくださいね。気になるサイズのブックトートがあれば、まずはラクサスで<span className="text-font-bolder">気軽にお試し</span>してみるのもおすすめです。ブックトート約300点の中からお選びいただけます！<br></br>
        購入前に実際の使い心地を体験できるのは嬉しいポイントです。
      </p> 
      <div className="border"></div>        
      <p className="text-max-width">📱憧れを日常に──ラクサスでディオールを体験しよう！</p>                           
      <Link to="https://laxus.co/app/pc/bags/dior" className="view-all-button">
        ディオールのバッグはこちら
      </Link>  
    </section>
    </div>
  </div>
</Layout>
)}

export default Post54

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 54}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
